import { cva } from 'class-variance-authority';
import type * as React from 'react';

const panelVariants = cva('rounded-[4px]', {
  variants: {
    variant: {
      data: 'bg-panel-data',
      action: 'border border-card-action-stroke',
      identity: 'border-2 border-identity-card-stroke bg-white',
    },
    size: {
      default: 'p-4',
      wide: 'px-6 py-4',
      compact: 'px-4 py-2',
      snug: 'px-2 py-3',
      roomy: 'px-4 py-3',
      flush: '',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});

type PanelVariant = 'data' | 'action' | 'identity';
type PanelSize = 'default' | 'wide' | 'compact' | 'snug' | 'roomy' | 'flush';

export interface PanelProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, 'className' | 'style'> {
  variant: PanelVariant;
  size?: PanelSize;
}

export function Panel({ variant, size, ...props }: PanelProps) {
  return (
    <div
      data-panel={variant}
      className={panelVariants({ variant, size })}
      {...props}
    />
  );
}
